import { FC } from 'react';
import styled from './index.module.scss';
import First from './First';
import Second from './Second';
import SecondEu from './SecondEu';
import Third from './Third';
import Fourth from './Fourth';
import { useLang } from '@/app/utils/useLang';
import Header from '@/components/XPower/elements/Header';
import { FusionIcon } from '@/components/XPower/svg';
import getLocal from '@/app/utils/getLocal';
import { EU_LIST } from '@/components/XPower/constants';

const XFusion: FC = () => {
    const { t } = useLang('xcode.xfusion');
    const { locale } = getLocal();

    return (
        <div className={styled.XFusion}>
            <Header icon={<FusionIcon />} desc={t('title')} subtitle={t('subtitle')} />
            <First />
            {EU_LIST.includes(locale) ? <SecondEu /> : <Second />}
            <Third />
            <Fourth />
        </div>
    );
};

export default XFusion;
